// extracted by mini-css-extract-plugin
module.exports = {"payButton":"styles_payButton___GQUe","errorAlert":"styles_errorAlert__J_uBy","spinnerOut":"styles_spinnerOut__dMBvk","spinnerIn":"styles_spinnerIn__wfvDK"};